/**
 * 行情页面自选股相关功能 
 * B股
 */

import newzxg from "../newzxg/web";
import quote_info from "../quote_info/web";
import dot from "dot";
import template_myfavorlist from "./myfavorlist_b.dot";
import txt from "../txt";

function showHasAdd(){
  $("#addzx").html("-删自选").removeAttr("href").addClass('deletezx');            
}

function showNoAdd(){
  $("#addzx").html( "+加自选" ).attr("href", "//quote.eastmoney.com/zixuan/?from=add").removeClass('deletezx');
}

let leftshowcount = 6
/**
 * 左侧我的自选股
 */
async function showLeftMyFavor(favorlist:Array<string>){
  let hqlist = await quote_info.simpleInfo(favorlist)
  
  $('#myfavorite tbody').html(dot.compile(template_myfavorlist)({
    list: hqlist.slice(0, leftshowcount),
    txt: txt
  }))
}



export default async function(code:string, options?:{
  /**
   * 左侧自选股列表数量
   */
  leftcount?:number,
  /**
   * 是否不用处理加自选按钮
   */
  ignore_btn?:boolean
}){

  if(options?.leftcount){
    leftshowcount = options.leftcount
  }

  let favorlist = await newzxg.defaultGroupList(code)  

  if(favorlist.result.check){ //已加自选
    showHasAdd()
  }

  showLeftMyFavor(favorlist.result.list.slice(0, leftshowcount + 4))

  setInterval(function(){ //自刷
    showLeftMyFavor(favorlist.result.list.slice(0, leftshowcount + 4))
  }, 60 * 1000)

  if(options?.ignore_btn && options.ignore_btn){
    return false
  }

  //加自选按钮
  $("#addzx").on('click', async function(){
    if(!favorlist.result.check){
      await newzxg.addDefaultStock(code)
      favorlist.result.check = true
      showHasAdd()
    }
    else{
      await newzxg.deleteDefaultStock(code)
      favorlist.result.check = false
      showNoAdd()
    }
  })


}